import {CHANNEL, getChannelPresentation} from '@shared/models/conversation';

/** Chuẩn hóa channel từ API về CHANNEL number để UI so sánh/hiển thị icon. */
export function normalizeChannelValue(channel: unknown): number {
    const numericChannel = Number(channel);
    if (!Number.isNaN(numericChannel) && channel !== null && channel !== '') {
        return numericChannel;
    }

    const channelKey = String(channel ?? '').trim().toLowerCase();
    const channelMap: Record<string, number> = {
        facebook: CHANNEL.FACEBOOK,
        instagram: CHANNEL.INSTAGRAM,
        shopee: CHANNEL.SHOPEE,
        zalo: CHANNEL.ZALO,
        zoa: CHANNEL.ZALO,
        lazada: CHANNEL.LAZADA,
        telegram: CHANNEL.TELEGRAM,
        whatsapp: CHANNEL.WHATSAPP,
        tiktok: CHANNEL.TIKTOK,
        zalo_personal: CHANNEL.ZALO_PERSONAL,
        'zalo-personal': CHANNEL.ZALO_PERSONAL,
        zalopersonal: CHANNEL.ZALO_PERSONAL,
    };

    return channelMap[channelKey] ?? 0;
}

/**
 * Trả về Phosphor icon class cho channel type.
 * Dùng chung cho cả desktop và mobile — KHÔNG tự viết switch riêng.
 *
 * @param channel - CHANNEL value (1=FB, 2=IG, 4=Shopee, 5=Zalo, 6=Lazada, 7=Telegram, 8=WA, 9=TikTok, 10=ZaloPersonal, 11=TikTokBiz)
 * @param options.isFill - Dùng ph-fill prefix (desktop sidebar) hay ph- (mobile)
 * @param options.isMessenger - FB inbox → messenger icon thay vì facebook icon
 * @param options.includeColor - Thêm text-primary cho FB, text-danger cho IG
 */
export function getChannelIcon(channel: number, options?: { isFill?: boolean; isMessenger?: boolean; includeColor?: boolean }): string {
    const prefix = options?.isFill ? 'ph-fill ' : '';
    const color = options?.includeColor ? (
        channel === CHANNEL.FACEBOOK ? ' text-primary' :
        channel === CHANNEL.INSTAGRAM ? ' text-danger' : ''
    ) : '';
    if (channel === CHANNEL.FACEBOOK && options?.isMessenger) {
        return `${prefix}ph-messenger-logo${color}`;
    }
    const icon = getChannelPresentation(channel)?.icon ?? 'globe';
    return `${prefix}ph-${icon}${color}`;
}

/**
 * Trả về Phosphor icon class cho channel với color class.
 * Dùng cho tabs/chips cần color (select-channel dialog).
 */
export function getChannelIconWithColor(channel: number): string {
    const icon = getChannelIcon(channel, { isFill: true });
    switch (channel) {
        case CHANNEL.FACEBOOK: return `${icon} text-primary`;
        case CHANNEL.INSTAGRAM: return `${icon} text-danger`;
        case CHANNEL.WHATSAPP: return `${icon} text-success`;
        default: return icon;
    }
}
